<template>
    <div class="pdf-preview-wrapper">
        <div class="pdf-preview">
            <div class="pdf-toolbar">
                <mdb-row class="d-flex align-items-center">
                    <mdb-col class="pdf-name">
                        <span>{{ name }}</span>
                    </mdb-col>

                    <div class="pdf-actions">
                        <button type="button" title="Print" @click="printPdf">
                            <mdb-icon class="fa fa-print"></mdb-icon>
                        </button>

                        <button type="button" title="Download" @click="downloadPdf">
                            <mdb-icon class="fa fa-download"></mdb-icon>
                        </button>
                    </div>
                </mdb-row>
            </div>
            <iframe
                :src="url + '#toolbar=0'"
                frameborder="0"
                scrolling="no"
            ></iframe>

            <!-- Clickable document area -->
            <div
                class="pdf-click-area"
                @click="openPdf"
                @mouseenter="showPopup"
                @mouseleave="showPopup"
            >
                <div v-if="showPreview" class="pdf-hover-preview">
                    <p>View</p>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import { mdbRow, mdbIcon, mdbCol } from 'mdbvue';
export default {
    name: 'PdfPreviewBtn',
    components: {
        mdbRow,
        mdbIcon,
        mdbCol
    },

    props: {
        url: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showPreview: false
        };
    },

    methods: {
        openPdf() {
            window.open(this.url, '_blank');
        },

        printPdf() {
            const printWindow = window.open(this.url, '_blank');

            if (printWindow) {
                printWindow.onload = function() {
                    printWindow.focus();
                    printWindow.print();
                };
            }
        },

        downloadPdf() {
            const link = document.createElement('a');
            link.href = this.url;
            link.download = this.name || 'document.pdf';

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        showPopup() {
            this.showPreview = !this.showPreview;
        }
    }
};
</script>

<style scoped>
.pdf-preview {
    position: relative;
    width: 350px;
    height: 250px;
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
}

.pdf-preview iframe {
    width: calc(100% + 15px);
    height: 100%;
    border: none;
}

/* Leave the PDF toolbar clickable */
.pdf-click-area {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
    cursor: pointer;
}

.pdf-toolbar {
    padding: 8px;
    background: rgba(26, 25, 25, 0.719);
    border-radius: 6px 6px 0 0;
    color: white;
}

.pdf-actions {
    display: flex;
    align-items: center;
    gap: 2px;
}

.pdf-actions button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    color: white;
}


.pdf-actions i {
    font-size: 16px;
    color: white;
}

.pdf-hover-preview {
    position: absolute;
    top: 80%;
    left: 80%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.75);
    color: white;
    padding: 8px 12px;
    border-radius: 5px;
    pointer-events: none;
    white-space: nowrap;
}

.pdf-hover-preview p {
    margin: 0;
}
</style>
